import axios from "axios";

const QURAN_API_BASES = [
    "https://api.alquran.cloud",
    "https://alquran.api.islamic.network",
    "https://alquran.api.alislam.ru",
];

async function getWithFallback(path, axiosConfig = {}) {
    let lastErr;

    for (const baseURL of QURAN_API_BASES) {
        try {
            const res = await axios.get(`${baseURL}${path}`, {
                timeout: 6000,
                ...axiosConfig,
            });
            return res;
        } catch (err) {
            lastErr = err;

            // If it's a 4xx, it's likely a "bad request" not a host outage → stop.
            const status = err?.response?.status;
            if (status && status >= 400 && status < 500) {
                throw err;
            }
            // otherwise try next base
        }
    }

    throw lastErr;
}

export async function fetchAyahArAlafasy(ayahNumber) {
    const path = `/v1/ayah/${ayahNumber}/ar.alafasy`;
    const response = await getWithFallback(path);
    return response.data;
}
